import React, { Component } from 'react';
// import logo from './logo.svg';
// import NavBar from './navbar/content/NavBar'
// import Content from './content/Content'
// import SideBar from './sidebar/SideBar'

import NavBar from '../CommonComponent/Navbar/NavBar'
import SideBar from '../CommonComponent/Sidebar/SideBar'
import { BrowserRouter, Route } from 'react-router-dom'
import './ParentApp.css';
// import './css/style.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import Dashboard from './content/DashBoard/container/DashBoard';
import Students from './content/Student/Container/Students';
import Parent from './content/Parent/Parent';
import Classes from './content/Classes/Classes'
// import AddStudent from './content/Student/Container/AddStudent';
import Attendance from './content/Attendance/Attendance';
import Subjects from './content/Subject/Subjects';
import Teachers from './content/Teacher/Container/Teachers';
import Marks from './content/Marks/Marks';
import Exams from './content/Exams/Exams';
import Events from './content/Events/Events';
import NoticeBoard from './content/NoticeBoard/NoticeBoard';
// require('bootstrap');


class ParentApp extends Component {
    state = {

        sideBarshow: true
    }
    userDetails={
        name:"Rahul Murmu",
        email:"readitoutanytime@gmail.com",
        profilePic:"rahul.jpg",
        type:"Parent"
    }

    sidebarMenu= [
        { id: 1, name: "DashBoard", icon: "fa fa-tachometer" },
        // { id: 2, name: "Student", icon: "fa fa-user" },
        // { id: 3, name: "Parent", icon: "fa fa-user-md" },
        // { id: 4, name: "Classes", icon: "fa fa-book" },
        { id: 5, name: "Attendance", icon: "fa fa-address-book" },
        { id: 6, name: "Marks", icon: "fa fa-subscript" },
        { id: 7, name: "Exam", icon: "fa fa-file-text" },
        { id: 8, name: "NoticeBoard", icon: "fa fa-address-book" },
        { id: 11, name: "Event", icon: "fa fa-cogs" },
        { id: 12, name: "TimeTable", icon: "fa fa-calendar" },
            
        ]


    render() {

        return (
            <BrowserRouter>
                <div className="wrapper">
                    <div className="sidebar">
                        <SideBar sidebarMenus={this.sidebarMenu} userDetails={this.userDetails}  />

                    </div>
                    <div className="content-wrapper">
                        <nav className="topbar "><NavBar userDetails={this.userDetails} /></nav>
                        <div className="container-fluid content">
                            {/* <Dashboard /> */}
                            {/* <Content show={this.state.content} /> */}
                            <Route path="/" exact component={Dashboard} />
                            <Route path="/DashBoard" exact component={Dashboard} />
                            <Route path="/Student" component={Students} />
                            <Route path="/Teacher" component={Teachers} />
                            <Route path="/Parent" component={Parent} />
                            <Route path="/Classes" component={Classes} />
                            <Route path="/Attendance" component={Attendance} />
                            <Route path="/Subject" component={Subjects} />
                            <Route path="/Marks" component={Marks} />
                            <Route path="/Exam" component={Exams} />
                            <Route path="/Event" component={Events}/>
                            <Route path="/TimeTable" render={() => <h1 className="text-center text-info">We are in Progress...</h1>} />
                            <Route path="/NoticeBoard" component={NoticeBoard}/>
                        </div>
                    </div>
                </div>
            </BrowserRouter>

        );
    }
}

export default ParentApp;
